import { render, staticRenderFns } from "./VersionsSet.vue?vue&type=template&id=0dce6700&scoped=true"
import script from "./VersionsSet.vue?vue&type=script&lang=js"
export * from "./VersionsSet.vue?vue&type=script&lang=js"
import style0 from "./VersionsSet.vue?vue&type=style&index=0&id=0dce6700&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dce6700",
  null
  
)

export default component.exports